export default "__VITE_ASSET__BCw7cYaB__"